(function(){
  const tracks = document.querySelectorAll('.marquee .marquee__track');
  if (!tracks.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  tracks.forEach(track => {
    const mask = track.closest('.marquee__mask');
    const pps = Number(track.getAttribute('data-speed-pps')) || 120;

    // Ensure we have enough content length for a smooth loop
    const need = mask.getBoundingClientRect().width * 2;
    while (track.scrollWidth < need) {
      track.insertAdjacentHTML('beforeend', track.innerHTML);
    }

    // Compute duration from pixel width and speed (px/sec)
    const durationSec = track.scrollWidth / pps;
    track.style.animationDuration = `${durationSec}s`;
    track.style.animationPlayState = 'running';
  });
})();
